jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupArtworkLoadMore();
	setupPopups();
	
	jQuery(window).on('load', function(){
		
		$container.isotope("layout");
		
	});
	
}

function setupArtworkLoadMore() {
	
	var amountPerLoad = 9;
	
	jQuery('#js_gallery_load_more .more').on('click', function(){
		
		var current = jQuery(this);
		var offset = current.attr('data-loaded');
		var tax = current.attr('data-tax');
		var term = current.attr('data-term');
		
		console.log(tax);
		
		jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=load_artwork&offset='+ offset + '&tax=' + tax + '&term=' + term,
			success:function(results){
				
				var newArtwork = jQuery(results);
				
				$container.isotope().append(newArtwork).isotope("appended", newArtwork);
				$container.imagesLoaded(function(){$container.isotope("layout", newArtwork)});

				current.attr('data-loaded', parseInt(offset) + amountPerLoad);
				
				if(newArtwork.length < 9) {
					jQuery('#js_gallery_load_more').hide();
				}
			
			}
		});
		
	});
	
}

function setupPopups() {
	
	jQuery('.other-images').magnificPopup({
		delegate: 'a',
		type: 'image',
		gallery: {
		  enabled: true
		},
	});
	
}
